import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '@app/shared';
import {NewPurchaseOrderComponent} from '@app/modules/purchase-order/new-purchase-order/new-purchase-order.component';
import {
  PurchaseOrderListComponent
} from '@app/modules/purchase-order/purchase-order-list/purchase-order-list.component';
import {SupplierPriceComponent} from '@app/modules/purchase-order/supplier-price/supplier-price.component';
import {
  SupplierPriceListComponent
} from '@app/modules/purchase-order/supplier-price-list/supplier-price-list.component';
import {ImportDataComponent} from '@app/modules/purchase-order/import-data/import-data.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'new-purchase-order',
        loadComponent: () => NewPurchaseOrderComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/new-purchase-order'}
      },
      {
        path: 'new-purchase-order/:/:id',
        loadComponent: () => NewPurchaseOrderComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/new-purchase-order'}
      },
      {
        path: 'purchase-order-list',
        loadComponent: () => PurchaseOrderListComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/purchase-order-list'}
      },
      {
        path: 'supplier-price',
        loadComponent: () => SupplierPriceComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/supplier-price'}
      },
      {
        path: 'supplier-price-list',
        loadComponent: () => SupplierPriceListComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/supplier-price-list'}
      },
      {
        path: 'import-data',
        loadComponent: () => ImportDataComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/import-data'}
      },


    ],
    runGuardsAndResolvers: 'always',
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PurchaseOrderRoutingModule {
}
